var _rect, _rect2, _rect3, _path, _path2, _path3, _rect4, _rect5, _rect6, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStublabLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1242,
    height: 331,
    viewBox: "0 0 1242 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 148.383,
    y: 121.668,
    width: 33.9541,
    height: 6.51704,
    rx: 3.25852,
    fill: "url(#paint0_linear_95_17)",
    stroke: "#60635F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 148.383,
    y: 135.45,
    width: 33.9541,
    height: 6.51704,
    rx: 3.25852,
    fill: "url(#paint1_linear_95_17)",
    stroke: "#60635F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 148.383,
    y: 149.231,
    width: 33.9541,
    height: 6.51704,
    rx: 3.25852,
    fill: "url(#paint2_linear_95_17)",
    stroke: "#60635F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.2296 138.708C88.2296 142.551 84.8758 145.725 80.6632 145.725C76.4507 145.725 73.0969 142.551 73.0969 138.708C73.0969 134.865 76.4507 131.691 80.6632 131.691C84.8758 131.691 88.2296 134.865 88.2296 138.708Z",
    fill: "url(#paint3_linear_95_17)",
    stroke: "#60635F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.37 241.441C186.37 245.284 183.016 248.458 178.804 248.458C174.591 248.458 171.237 245.284 171.237 241.441C171.237 237.598 174.591 234.424 178.804 234.424C183.016 234.424 186.37 237.598 186.37 241.441Z",
    fill: "url(#paint4_linear_95_17)",
    stroke: "#60635F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42888 223.4C-3.38949 171.858 8.26404 125.761 15.4605 110.519C18.4309 104.228 19.4523 101.914 19.7405 101.181C19.3382 101.77 20.0955 100.277 19.7405 101.181C19.8246 101.057 19.9595 100.843 20.1658 100.496C24.6537 92.9615 27.5298 90.0766 33.6097 83.5831C39.4725 77.3213 43.3281 74.2203 50.4145 69.1754C59.3942 62.7828 64.8401 59.4114 75.2857 55.3942C87.2352 50.7988 94.7056 49.8557 107.551 48.5036C126.892 46.4679 156.853 51.2363 159.167 51.6124C159.273 51.6296 159.36 51.6475 159.465 51.6725C160.428 51.9036 165.932 53.2547 177.459 56.647C188.131 59.7875 192.862 62.0238 202.271 68.5082C202.31 68.535 202.348 68.5623 202.386 68.5903C203.516 69.4234 221.408 82.7087 229.218 94.2323C234.456 100.493 237.245 105.852 241.318 111.146L245.689 118.667C247.627 122 245.222 126.18 241.367 126.18H197.229C194.468 126.18 192.229 123.941 192.229 121.18V112.387C192.229 109.626 189.991 107.387 187.229 107.387H159.31H129.061H67.514C64.7526 107.387 62.514 109.626 62.514 112.387V166.908C62.514 169.67 64.7526 171.908 67.514 171.908H129.061H187.229C189.991 171.908 192.229 169.67 192.229 166.908V157.685C192.229 154.848 194.609 152.582 197.444 152.677C256.469 154.645 250.186 149.15 250.058 159.691C250.055 159.894 250.067 160.096 250.091 160.298C250.372 162.628 252.245 178.393 252.745 188.822C253.311 200.619 252.762 218.962 252.745 219.504L252.744 219.531C252.733 220.071 252.38 235.539 250.056 245.2L249.902 245.841C247.741 254.83 246.362 260.563 241.99 269.004C233.036 286.287 214.956 299.601 213.22 300.854C213.122 300.925 213.033 300.982 212.93 301.045L201.658 307.842L190.535 314.549C190.333 314.671 190.121 314.779 189.903 314.871L175.443 320.996L159.405 325.355C159.342 325.373 159.288 325.386 159.224 325.401C157.959 325.689 143.009 329.058 133.076 329.766C125.231 330.326 114.273 329.766 112.928 329.766C111.584 329.766 97.0185 328.34 87.3851 325.381C80.5756 323.29 76.9737 321.515 70.5803 318.491C62.3909 314.617 57.9907 312.053 50.4145 307.215C46.7553 304.879 41.4237 301.101 40.4778 300.429C40.3797 300.359 40.2852 300.286 40.1925 300.209L34.2819 295.313L28.3564 289.791C28.2736 289.714 28.195 289.636 28.1176 289.553C27.3571 288.74 22.9782 284.052 20.1658 280.906C16.6522 276.974 12.5823 270.306 11.6326 268.722C11.4948 268.492 11.3414 268.274 11.1704 268.067L6.79233 262.787C4.09011 259.529 6.4078 254.596 10.6413 254.596H57.514C60.2754 254.596 62.514 256.834 62.514 259.596V269.015C62.514 271.776 64.7526 274.015 67.514 274.015H129.061H187.229C189.991 274.015 192.229 271.776 192.229 269.015V213.241C192.229 210.479 189.991 208.241 187.229 208.241H137.8H67.514C64.7526 208.241 62.514 210.479 62.514 213.241V222.66C62.514 225.421 60.2754 227.66 57.514 227.66H33.6097H8.33274C5.86053 227.66 3.7531 225.851 3.42888 223.4Z",
    fill: "url(#paint5_linear_95_17)",
    stroke: "#1B1B1B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73.0969,
    y: 224.401,
    width: 33.9541,
    height: 6.51704,
    rx: 3.25852,
    fill: "url(#paint6_linear_95_17)",
    stroke: "#60635F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.0969,
    y: 238.183,
    width: 33.9541,
    height: 6.51704,
    rx: 3.25852,
    fill: "url(#paint7_linear_95_17)",
    stroke: "#60635F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 73.0969,
    y: 251.964,
    width: 33.9541,
    height: 6.51704,
    rx: 3.25852,
    fill: "url(#paint8_linear_95_17)",
    stroke: "#60635F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M414.398 173.913C429.898 174.026 441.705 177.696 449.819 184.921C457.934 191.981 461.942 202.427 461.841 216.26L461.619 246.759C461.516 260.925 457.438 271.646 449.385 278.921C441.499 286.03 429.808 289.362 414.311 288.916L337.822 287.109L338.02 259.86L425.268 260.495C427.935 260.514 429.278 259.191 429.297 256.524L429.661 206.525C429.68 203.859 428.357 202.516 425.69 202.496L381.191 202.172C365.692 202.059 353.967 198.557 346.017 191.666C338.234 184.776 334.393 174.248 334.497 160.081L334.711 130.582C334.812 116.749 338.973 106.112 347.194 98.6721C355.416 91.0651 367.276 87.4846 382.773 87.9308L455.512 89.7104L455.314 116.96L371.066 116.346C368.399 116.327 367.056 117.734 367.035 120.567L366.678 169.566C366.659 172.232 367.983 173.575 370.649 173.595L414.398 173.913ZM564.392 159.505L528.643 159.245L527.911 259.742C527.895 261.909 528.971 263 531.137 263.015L563.636 263.252L563.451 288.751L540.201 288.582C525.202 288.473 514.307 285.477 507.516 279.594C500.892 273.712 497.63 263.938 497.729 250.272L498.393 159.024L480.394 158.893L480.567 135.144L498.566 135.275L498.85 96.276L529.099 96.4962L528.815 135.495L564.565 135.755L564.392 159.505ZM615.712 291.382C603.046 291.29 593.814 288.806 588.016 283.93C582.386 278.889 579.617 270.035 579.709 257.369L580.593 135.872L610.843 136.092L609.916 263.339C609.899 265.672 610.974 266.847 613.141 266.863L660.389 267.206L661.091 136.458L691.34 136.678L690.727 289.678L663.727 289.481L661.099 272.712C659.72 279.035 656.769 283.764 652.246 286.898C647.723 290.032 641.462 291.569 633.462 291.511L615.712 291.382ZM725.554 289.931L727.086 79.437L757.335 79.6572L756.811 151.655C760.226 140.513 769.183 134.995 783.683 135.1L801.182 135.228C813.848 135.32 823.08 137.887 828.877 142.93C834.674 147.972 837.526 156.826 837.434 169.493L836.8 256.49C836.702 269.99 833.55 279.384 827.345 284.672C821.307 289.795 811.123 292.221 796.791 291.95L725.554 289.931ZM756.729 162.905L755.98 265.902L803.225 266.746C805.391 266.762 806.483 265.603 806.5 263.27L807.228 163.273C807.245 160.939 806.17 159.765 804.004 159.749L760.255 159.431C757.922 159.414 756.746 160.572 756.729 162.905ZM869.622 290.98L871.155 80.4858L901.654 80.7078L900.122 291.202L869.622 290.98ZM964.695 293.922C952.196 293.831 943.047 291.348 937.249 286.472C931.619 281.431 928.85 272.578 928.942 259.911L929.106 237.412C929.203 224.079 932.27 214.851 938.307 209.728C944.513 204.44 954.699 201.847 968.865 201.95L1008.11 202.236L1008.37 167.487C1008.38 165.32 1007.31 164.229 1005.14 164.213L938.89 163.981L939.078 138.232L998.576 138.665C1012.91 138.603 1023.22 141.428 1029.52 147.14C1035.81 152.686 1038.9 162.376 1038.8 176.209L1037.96 292.206L1010.71 292.007L1008.34 274.74C1006.96 281.23 1004 286.125 999.479 289.425C995.123 292.561 988.861 294.098 980.695 294.039L964.695 293.922ZM1007.62 269.734L1007.95 224.235L962.455 223.904C960.288 223.888 959.197 224.964 959.181 227.13L958.899 265.879C958.882 268.213 959.957 269.387 962.124 269.403L1007.62 269.734ZM1070.27 292.441L1071.8 81.9464L1102.05 82.1667L1101.53 154.165C1104.94 143.023 1113.9 137.504 1128.4 137.61L1145.9 137.737C1158.57 137.83 1167.8 140.397 1173.59 145.439C1179.39 150.481 1182.24 159.336 1182.15 172.002L1181.52 259C1181.42 272.499 1178.27 281.893 1172.06 287.182C1166.02 292.305 1155.84 294.731 1141.51 294.46L1070.27 292.441ZM1101.45 165.414L1100.7 268.412L1147.94 269.256C1150.11 269.271 1151.2 268.113 1151.22 265.779L1151.95 165.782C1151.96 163.449 1150.89 162.274 1148.72 162.259L1104.97 161.94C1102.64 161.923 1101.46 163.081 1101.45 165.414Z",
    fill: "url(#paint9_linear_95_17)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_95_17",
    x1: 165.36,
    y1: 121.168,
    x2: 165.36,
    y2: 128.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_95_17",
    x1: 165.36,
    y1: 134.95,
    x2: 165.36,
    y2: 142.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_95_17",
    x1: 165.36,
    y1: 148.731,
    x2: 165.36,
    y2: 156.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_95_17",
    x1: 80.6632,
    y1: 131.191,
    x2: 80.6632,
    y2: 146.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_95_17",
    x1: 178.804,
    y1: 233.924,
    x2: 178.804,
    y2: 248.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_95_17",
    x1: 126.5,
    y1: 48,
    x2: 126.5,
    y2: 330.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_95_17",
    x1: 90.074,
    y1: 223.901,
    x2: 90.074,
    y2: 231.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_95_17",
    x1: 90.074,
    y1: 237.683,
    x2: 90.074,
    y2: 245.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_95_17",
    x1: 90.074,
    y1: 251.464,
    x2: 90.074,
    y2: 258.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_95_17",
    x1: 363,
    y1: 135,
    x2: 366,
    y2: 269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838181"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStublabLogo);
export default __webpack_public_path__ + "static/media/stublab-logo.4487178ca0ee981e1d5bde82b1b38feb.svg";
export { ForwardRef as ReactComponent };